<template>
<div class="chapter">
<div class="inner_page">
<div class="introduction1" id="introduction1">
<p class="centerImage" id="cha1"><img alt="image" id="img14" src="images/img14.jpg"/></p>
<p class="caption">(1) Chart of Pearl Harbor, 7 December 1941</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AttackonPearlHarbor_introduction1.vue?53be0c75